export enum DeviceInterfaceTypes {
  Ccp = 'ccp',
  OmnicastSenderFTP = 'OmnicastSenderFTP',
}
